import styled from 'styled-components';
import { forwardRef, useRef, useState } from 'react';
import throttle from '../../utils/throttle';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledSvg = styled.svg.withConfig({
  displayName: "VerticalNavMenuItemHitbox__StyledSvg",
  componentId: "fi7pt1-0"
})(["pointer-events:none;position:fixed;z-index:9999;top:0;left:0;path{pointer-events:auto;fill:transparent;cursor:pointer !important;}"]);
const VerticalNavMenuItemHitbox = /*#__PURE__*/forwardRef(({
  setIsMouseMovingTowardsSubmenu,
  hitboxPath,
  width = '0',
  height = '0'
}, ref) => {
  const toggleIsMouseMovingTowardsSubmenu = nextState => () => {
    setIsMouseMovingTowardsSubmenu(nextState);
  };
  const [hideHitbox, setHideHitbox] = useState(false);
  const previousMousePositionX = useRef(undefined);
  const onMouseMove = throttle(e => {
    if (previousMousePositionX.current !== undefined && e.screenX - previousMousePositionX.current < 0) {
      previousMousePositionX.current = undefined;
      setIsMouseMovingTowardsSubmenu(false);
      setHideHitbox(true);
    }
    previousMousePositionX.current = e.screenX;
  }, 30);
  if (hideHitbox) return null;
  return /*#__PURE__*/_jsx(StyledSvg, {
    width: width,
    height: height,
    "aria-hidden": "true",
    children: /*#__PURE__*/_jsx("path", {
      ref: ref,
      d: hitboxPath,
      "data-test-id": "hs-vertical-nav-item-hitbox",
      onMouseEnter: toggleIsMouseMovingTowardsSubmenu(true),
      onMouseMove: onMouseMove,
      onMouseLeave: toggleIsMouseMovingTowardsSubmenu(false)
    })
  });
});
export default VerticalNavMenuItemHitbox;